angular
  .module("admin.reports")
  .controller(
    "RemovedSubordinatesReportCtrl",
    function (dateRangePickerConfig, ReportsResource, $http, config, RemovalReasons) {
      var ctrl = this;

      ctrl.page = 1;
      ctrl.limit = 20;
      ctrl.loading = false;
      ctrl.search = "";
      ctrl.lang = "pt-BR";

      ctrl.datePickerOpts = angular.extend(angular.copy(dateRangePickerConfig), {
        eventHandlers: {
          "apply.daterangepicker": () => {
            ctrl.page = 1;
            ctrl.loadReport();
          },
        },
      });

      ctrl.filter = {
        period: {
          startDate: moment().subtract(30, "day").toDate(),
          endDate: moment().toDate(),
        },
      };

      ctrl.loadReport = function () {
        ctrl.loading = true;
        delete ctrl.report;

        var params = {
          page: ctrl.page,
          limit: ctrl.limit,
          action: "SUBORDINATE_REMOVED",
          lang: ctrl.lang,
        };

        if (ctrl.search && ctrl.search.trim()) {
          params.search = ctrl.search.trim();
        }

        if (ctrl.filter.period && ctrl.filter.period.startDate) {
          params.startDate = moment(ctrl.filter.period.startDate)
            .startOf("day")
            .toISOString();
        }

        if (ctrl.filter.period && ctrl.filter.period.endDate) {
          params.endDate = moment(ctrl.filter.period.endDate)
            .endOf("day")
            .toISOString();
        }

        ReportsResource.activityLogs(params, (response) => {
          ctrl.loading = false;
          if (response && response.data && response.data.data) {
            ctrl.report = {
              data: response.data.data,
              metadata: response.data.metadata
            };
          } else {
            ctrl.report = {
              data: [],
              metadata: {
                total: 0,
                page: 1,
                limit: ctrl.limit,
                totalPages: 0
              }
            };
          }
        }, (error) => {
          ctrl.loading = false;
          console.error("[RemovedSubordinatesReportCtrl] Erro ao carregar:", error);
          ctrl.report = {
            data: [],
            metadata: {
              total: 0,
              page: 1,
              limit: ctrl.limit,
              totalPages: 0
            }
          };
        });
      };

      ctrl.searchReport = function () {
        ctrl.page = 1;
        ctrl.loadReport();
      };

      ctrl.changePage = function () {
        ctrl.loadReport();
      };

      ctrl.getRemovalReasonLabel = function (reason) {
        return RemovalReasons.getLabel(reason);
      };

      ctrl.init = function () {
        ctrl.loadReport();
      };

      ctrl.init();
    }
  );
